import React from 'react';
import Card from '../components/card';
import { DollarTextField } from '../components/MaskedTextField';
import style from '../styles/form';
import { LoanCard } from './card-lenses';

const validatePurchasePrice = (num) =>
  num >= 5000 && num <= 100000000 ? '' : 'Purchase price must be between $5,000 and $100,000,000';

const isPurchase = (loan) => {
  const purchaseScenarios = ['Purchase', 'Qualify'];
  return purchaseScenarios.indexOf(loan.get('scenario')) > -1;
};

const titleText = (loan) => {
  if (isPurchase(loan)) {
    return 'What is the price of the property to be purchased?';
  }
  return 'What is the purchase price you wish to be pre-approved for?';
};

const PurchasePrice = ({ model, onChange, ...cardProps }) => (
  <Card title={titleText(model)} {...cardProps}>
    <DollarTextField
      value={model.get('purchasePrice')}
      onChange={onChange.bind(null, 'purchasePrice')}
      style={style.threeQuarters}
      floatingLabelText="Purchase Price ($)"
      validate={validatePurchasePrice}
    />
  </Card>
);

PurchasePrice.id = 'PurchasePrice';

PurchasePrice.completed = ({ model }) =>
  !DollarTextField.validate(model.get('purchasePrice'), validatePurchasePrice);

export default LoanCard(PurchasePrice);



// WEBPACK FOOTER //
// ./src/cards/purchase-price.js